import React from 'react';
import FieldValidation from '../Fragments/FieldValidation';
import FieldError from '../Fragments/FieldError';
import InputElement from 'react-input-mask';

let Validation = require('../Managers/Validation.js');
let Quote = require('../Managers/Quote');

const NumberInput = React.createClass({
    propTypes: {
        fieldName:  React.PropTypes.string.isRequired,
        helpText:   React.PropTypes.string,
        question:   React.PropTypes.string.isRequired,
        inputMask:  React.PropTypes.string.isRequired,
        maskChar:   React.PropTypes.string,
        errors:     React.PropTypes.array,
        hasError:   React.PropTypes.bool.isRequired,
        loadCachedValue: React.PropTypes.bool.isRequired,
    },

    getDefaultProps() {
        return {
            inputMask: '9999999999999999999999999',
            maskChar: null,
            isDateField: false,
            errors: [],
            hasError: false,
        };
    },

    getInitialState() {
        return {
            activeValue: (this.props.loadCachedValue) ? Quote.getCurrentAnswer(this.props.fieldName) : null,
            isHelpVisible: false,
            isValid: (Quote.getCurrentAnswer(this.props.fieldName)) ? true : false,
            hasError: false,
            errors: null,
        };
    },

    doValidation() {
        if(this.props.fieldName == "phone_number"){
        let validation = Validation.validate(this.props.fieldName, $('#phone_number').val())[0];
        this.setState(validation);
        if (validation.isValid) {
            this.setState({
                activeValue: $('#phone_number').val(),
                isValid: true
            });
            Quote.set(this.props.fieldName, $('#phone_number').val());
            localStorage.setItem("phone_number",$('#phone_number').val());
        } else {
            Quote.set(this.props.fieldName, "");
        }
    }

        if (!Quote.hasAnswers(this.props.fieldName)) {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }
        return true;
    },

    helpVisibility() {
        if (this.state.isHelpVisible) {
            this.setState({
                isHelpVisible: false,
            });
        } else {
            this.setState({
                isHelpVisible: true,
            });
        }
    },

    setActiveValue(event) {
        let validation = Validation.validate(this.props.fieldName, event.target.value)[0];
        this.setState(validation);
        if (validation.isValid) {
            this.setState({
                activeValue: event.target.value,
                isValid: true
            });
            Quote.set(this.props.fieldName, event.target.value);
        } else {
            Quote.set(this.props.fieldName, "");
        }
    },

    render() {
        let topClass = (this.props.helpText) ? 'question-top with-help' : 'question-top without-help';
        return (
            <div>
                <question-row>
                    <div className="question-main">
                        <div className={topClass}>
                            <label>{this.props.question}</label>
                        </div>
                        <div className="question-input">
                            <InputElement
                                name={this.props.fieldName}
                                id={this.props.fieldName}
                                className="form-control"
                                mask={this.props.inputMask}
                                maskChar={this.props.maskChar}
                                onBlur={this.setActiveValue}
                                // defaultValue={Quote.getCurrentAnswer(this.props.fieldName)}
                                defaultValue={this.props.fieldName == "phone_number" ? localStorage.getItem(this.props.fieldName) : Quote.getCurrentAnswer(this.props.fieldName)}
                                pattern="\d*"
                            />

                            {this.state.isHelpVisible ? (
                                <div className="hint-container">
                                    <div className="hint">
                                        <div className="arrow arrow-left" />
                                        {this.props.helpText}
                                    </div>
                                </div>
                            ) : null}
                            {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                        </div>
                    </div>
                    <div className="question-extra">
                        <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                    </div>
                </question-row>
            </div>
        );
    }
});

export default NumberInput;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/NumberInput.js
 **/